import { useCustomers } from '@melio/ar-domain';
import { forwardRef } from '@melio/platform-utils';

import { CreateCustomerScreen } from './screens';

type CreateCustomerActivityProps = {
  onDone: VoidFunction;
  onClose: VoidFunction;
  isOpen: boolean;
  onError?: ErrorFunction;
};

export const CreateCustomerActivity = forwardRef<CreateCustomerActivityProps>(({ onDone, onError, ...props }, ref) => {
  const { create, isMutating } = useCustomers({ enabled: false });

  return (
    <CreateCustomerScreen
      onSubmit={({ customerName, email }) => {
        create({ companyName: customerName, contactName: customerName, contactEmail: email })
          .then(onDone)
          .catch(onError);
      }}
      isSaving={isMutating}
      ref={ref}
      {...props}
    />
  );
});
